const variants = {
    custom: {
        // fe-ui unstyles the overlay and stacks dialogContainer at layer2.
        // layer7 sits above the wizards (layer6), below dialog Modals (layer8).
        overlay: {
            zIndex: 'layer7',
        },
        dialogContainer: {
            zIndex: 'layer7',
        },
        body: {
            padding: 6,
            position: 'relative',
            overflowY: 'auto',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
        },
        footer: {
            padding: 4,
            borderTop: '1px solid',
            borderColor: 'gray.200',
            width: '100%',
            flexDirection: 'column',
            gap: 4,
            position: 'relative',
        },
        header: {
            paddingY: 4,
            paddingX: 6,
            boxShadow: 'md',
            lineHeight: 1.5,
            fontSize: 'base',
        },
        closeButton: {
            width: 5,
            height: 5,
            padding: 1,
            fontSize: 'xs',
            borderRadius: 'sm',
        },
    },
};

const sizes = {
    sidebar: {
        dialog: {
            // The subtraction of 1px allows for the Drawer to retain the border from the FacilitySidebar container
            maxWidth: 'calc(21.875rem - 1px)',
        },
    },
};

const defaultProps = {
    variant: 'custom',
};

const drawerStyles = {
    variants,
    sizes,
    defaultProps,
} as const;

export default drawerStyles;
